import React from "react";
import Modal from "@mui/material/Modal";
import {
    FormControlLabel,
    Grid,
    IconButton,
    Radio,
    RadioGroup,
    Stack,
    Tooltip,
} from "@mui/material";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import styled from "styled-components";
import CloseIcon from "@mui/icons-material/Close";
import PipelineDurationCardsExpand from "src/components/pipeline-duration-cards-expand";
import WorkflowPicker from "src/components/workflow-picker";
import RepoPicker from "src/components/repo-picker";
import FormControl from "@mui/material/FormControl";

const SubtitleText = styled.span`
    font-size: 12px;
    font-weight: 400;
    color: ${({ theme }) => theme.palette.primary.main};
`;

const PipelineStageModal = ({
    open,
    handleClose,
    data,
    repo,
    setRepo,
    workflow,
    durationMode,
    handleDurationModeChange,
    allWorkflows,
    setWorkflow,
    fetchAction,
}) => {
    if (!data) return null;
    const style = {
        position: "absolute",
        maxWidth: "98%",
        maxHeight: "80vh",
        height: "100%",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: "100%",
        bgcolor: "background.paper",
        borderRadius: 4,
        boxShadow: 24,
        p: 4,
    };

    const showWorkflowPicker = () => {
        if (allWorkflows && allWorkflows.length <= 1 && allWorkflows[0] === repo) {
            return true;
        }
        return false;
    };

    return (
        <div>
            <Modal
                open={open}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Stack>
                    <Box sx={style}>
                        <Stack
                            direction="row"
                            alignItems="center"
                            spacing={0.5}
                            justifyContent="space-between"
                            style={{ width: "100%" }}
                            mb={4}
                        >
                            <Grid
                                container
                                direction="row"
                                alignItems="center"
                                style={{ width: "73%" }}
                            >
                                <Grid item>
                                    <Typography
                                        id="modal-modal-title"
                                        variant="h6"
                                        component="h4"
                                        style={{ width: "287px" }}
                                    >
                                        Duration per pipeline stage
                                    </Typography>
                                </Grid>
                                <Grid item>
                                    <RepoPicker
                                        repo={repo}
                                        setRepo={setRepo}
                                        data={fetchAction.data && fetchAction.data.durationPerStage}
                                    />
                                </Grid>
                                <Grid item>
                                    {!showWorkflowPicker() && (
                                        <WorkflowPicker
                                            setWorkflow={setWorkflow}
                                            workflow={workflow}
                                            data={
                                                fetchAction.data &&
                                                fetchAction.data.durationPerStage[repo]
                                            }
                                        />
                                    )}
                                </Grid>
                            </Grid>
                            <FormControl>
                                <RadioGroup
                                    aria-labelledby="demo-controlled-radio-buttons-group"
                                    name="controlled-radio-buttons-group"
                                    value={durationMode}
                                    onChange={handleDurationModeChange}
                                    row
                                >
                                    <FormControlLabel
                                        value="overall"
                                        control={<Radio size="small" />}
                                        label={
                                            <Tooltip title="The duration it took for the stage to complete its tasks.">
                                                <Typography sx={{ fontSize: 12 }}>
                                                    Execution time
                                                </Typography>
                                            </Tooltip>
                                        }
                                    />
                                    <FormControlLabel
                                        value="total"
                                        control={<Radio size="small" />}
                                        label={
                                            <Tooltip title=" Total time, including user interaction. Accounts for machine time and any manual steps involved.">
                                                <Typography sx={{ fontSize: 12 }}>
                                                    Overall duration
                                                </Typography>
                                            </Tooltip>
                                        }
                                    />
                                </RadioGroup>
                            </FormControl>
                            <IconButton
                                size="small"
                                aria-label="see knowledge base"
                                color="secondary"
                                onClick={handleClose}
                            >
                                <CloseIcon />
                            </IconButton>
                        </Stack>
                        <SubtitleText id="modal-modal-description" sx={{ mt: 2 }}>
                            Edit the parameters of your deployments.
                        </SubtitleText>
                        <PipelineDurationCardsExpand data={data} durationMode={durationMode} />
                    </Box>
                </Stack>
            </Modal>
        </div>
    );
};

export default PipelineStageModal;
